import React, {  } from 'react'
import { useFormik, useField } from "formik";
import { connect } from "react-redux";

//Acciones redux
import { createRepresentative } from "../../actions/representativeActions";

import RequestRepresentative from '../../containers/Requests/RequestEcoTiendaOrMaster/RequestEcoTiendaOrMaster';
import { Translate } from '../../language';
import * as Yup from 'yup';
import { useHistory } from 'react-router-dom';
//Componetnes
//import { Places } from "../../../components/form/Places";


function RegisterForm({
  //Funcion Redux
  createRepresentative}) {
  // const {logging} = useSelector((state) => state.auth.login)
  const history = useHistory()

  const validationSchema = Yup.object().shape({
    chamberOfCommerce: Yup.mixed().when(['kindOfPerson'], (kindOfPersonValue, schema) => {
      return schema.test("fileSize", "Requerido", (value) => {
        if (kindOfPersonValue ==='natural') {
          return true;
        }
        else {
          if (value && value.type) {
            return value.type.includes('pdf')
          } else {
            return false;
          }
        }

      })
    }),
    bankCertification: Yup.mixed().when(['kindOfPerson'], (kindOfPersonValue, schema) => {
      return schema.test("fileSize", "Requerido", (value) => {
        if (kindOfPersonValue ==='natural') {
          return true;
        }
        else {
          if (value && value.type) {
            return value.type.includes('pdf')
          } else {
            return false;
          }
        }

      })
    }),
    rut: Yup.mixed().when(['kindOfPerson'], (kindOfPersonValue, schema) => {
      return schema.test("fileSize", "Requerido", (value) => {
        if (kindOfPersonValue ==='natural') {
          return true;
        }
        else {
          if (value && value.type) {
            return value.type.includes('pdf')
          } else {
            return false;
          }
        }

      })
    }),
    kindOfPerson: Yup.string().required('Requerido'),
    businessEmail: Yup.string().required('Requerido'),
    businessPhone: Yup.string().required('Requerido'),
    reasonForRequest: Yup.string().required('Requerido'),
    socialReason: Yup.string().required('Requerido'),

    businessCountry: Yup.string().required('Requerido'),
    businessDepartment: Yup.string().required('Requerido'),
    businessCity: Yup.string().required('Requerido'),

    businessLocation: Yup.string().required('Requerido'),
    businessAddress: Yup.string().required('Requerido'),


  });


  const formik = useFormik({
    validationSchema,
    initialValues: {
      kindOfPerson: '',
      category: '',
      businessEmail: '',
      businessPhone: '',
      socialReason: '',
      rut: '',
      chamberOfCommerce: '',
      bankCertification: '',
      commercialReference: '',
      businessCountry: '',
      businessDepartment: '',
      businessCity: '',
      businessLocation: '',
      businessAddress: '',
      reasonForRequest: '',
      identificationNumber: '',
    },
    onSubmit: (values) => {
      const formData = new FormData();
      for (var key in values) {
          formData.append(key, values[key]);
      }
      createRepresentative(formData,history)
      //createFranchise(values)
    },
    // handleChange: (event)=>{
    //   console.log()
    // }
  });
  return <RequestRepresentative tittle={Translate('requestReprsentative', 'es')} isEcoTienda formik={formik}/>
}

export default connect(null, { createRepresentative })(RegisterForm);
